import Image from 'next/image'
import { usePathname } from 'next/navigation'
import router from 'next/router'

import { Feed } from '@/api/models/news/lib/news.types'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { cn } from '@/app/utils'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

type Props = {
  className?: string
  proposalItem: Feed
}

const stylesTransition = 'transition-all duration-500 ease-out'

const ProposalBanner = ({ className, proposalItem }: Props) => {
  const { reachGoal } = useYandexMetrika()
  const pathname = usePathname()

  const onBannerClick = () => {
    reachGoal(
      pathname === '/'
        ? YandexMetrikaEvent.MAIN_PROPOSAL_DETAIL
        : YandexMetrikaEvent.FEED_PROPOSAL_DETAIL
    )
    router.push(`/feed/${proposalItem?.id}?type=proposal`)
  }

  return (
    <button
      className={cn(
        'group relative mb-12 block h-[268px] w-full cursor-pointer overflow-hidden rounded-16 bg-grey-70 text-left lg:h-[260px]',
        className
      )}
      onClick={onBannerClick}
    >
      {proposalItem && (
        <Image
          src={proposalItem?.picture}
          alt={proposalItem?.shortTitle}
          className={cn(
            'pointer-events-none absolute inset-0 z-[1] h-full w-full object-cover text-white',
            `group-hover:scale-[1.18] ${stylesTransition}`
          )}
          width={442}
          height={232}
          onContextMenu={e => e.preventDefault()}
          onDrag={e => e.preventDefault()}
        />
      )}
      <div
        className={cn(
          'relative z-[2] flex h-full w-full flex-col justify-between bg-[rgba(0,0,0,.45)] p-32 sm:p-16',
          `group-hover:bg-transparent ${stylesTransition}`
        )}
      >
        <div className="mb-16" />
        <h3 className="line-clamp-3 max-w-[370px] break-words font-bold text-white text-24 lg:text-18 sm:text-14">
          {proposalItem?.shortTitle}
        </h3>
      </div>
    </button>
  )
}
export default ProposalBanner
